import React, { useState, useEffect } from 'react';
import { TabbedInterface } from 'Permafrost/index';
/**
 * An a11y-friendly tabbed interface; allows the user to tab between different sections
 * of a container.
 *
 * If the URL will change as the user moves from section to section, the `TabNavigation` component
 * should be used instead.
 */
export function TabbedContainer(props) {
    const { className, defaultSection, fullWidthTabs, id, sections, current, setCurrent } = props;
    const [tabs, setTabs] = useState([]);
    const [sectionContent, setSectionContent] = useState({});
    // If the sections (aka tabs) we passed in change,
    // then update our local state and,
    // if the tab we were on no longer exists,
    // then return to the default selection
    useEffect(() => {
        setTabs(sections.map((section) => ({
            id: section.id,
            name: section.name,
            disabled: section.disabled,
            tooltip: section.tooltip ? section.tooltip : undefined,
        })));
        setSectionContent(sections.reduce((acc, section) => {
            return Object.assign(Object.assign({}, acc), { [section.id]: section.content });
        }, {}));
        if (!sections.some((section) => section.id === current)) {
            setCurrent(defaultSection || sections[0].id);
        }
    }, [sections]);
    return (React.createElement(TabbedInterface, { tabType: "section", tabs: tabs, className: className, currentTab: current, "data-cy": props['data-cy'], id: id, fullWidthTabs: fullWidthTabs, onTabSelect: (id) => setCurrent(id) }, sectionContent[current]));
}
//# sourceMappingURL=TabbedContainer.js.map